
import React from 'react';
import { useAppSelector } from '../../app/hooks';
import ResourcesIndexUI from '../resources/resourceIndexUI/ResourcesIndexUI';
import { useTranslation } from 'react-i18next';
import { useGetForUserQuery } from '../../app/services/userResourceApi';

const UserResourceIndex = () => {
  const { t:_ } = useTranslation();
  const isAuthenticated = useAppSelector((state) => state.auth.userToken?.token) || false;
  const {data, isLoading,} = useGetForUserQuery(undefined, {skip:!isAuthenticated});
  return (
    <div>
      {isLoading ? <p>{_("Loading")}</p> : <ResourcesIndexUI resources={data} />}
    </div>
  );
};

export default UserResourceIndex;
